import { useEffect, useRef, useState } from "react";

interface IdleTrackerProps {
	idleLimit?: number; // in ms
	onIdle?: () => void;
}

export default function IdleTracker({
	idleLimit = 600000 * 10, // default 10 mins
	onIdle,
}: IdleTrackerProps) {
	const [_idleTime, setIdleTime] = useState<number>(0);
	const idleTimeRef = useRef<number>(0);

	const resetIdleTimer = () => {
		idleTimeRef.current = 0;
		setIdleTime(0);
	};

	useEffect(() => {
		const events: (keyof WindowEventMap)[] = [
			"mousemove",
			"keydown",
			"scroll",
			"touchstart",
		];

		events.forEach((event) => window.addEventListener(event, resetIdleTimer));

		const interval = setInterval(() => {
			idleTimeRef.current += 1000;
			setIdleTime(idleTimeRef.current);

			if (idleTimeRef.current >= idleLimit) {
				if (onIdle) onIdle();
			}
		}, 1000);

		return () => {
			events.forEach((event) =>
				window.removeEventListener(event, resetIdleTimer),
			);
			clearInterval(interval);
		};
	}, [idleLimit, onIdle, resetIdleTimer]);

	return null; // No UI, just tracking logic
}
